import React from "react";
import { podcastDetails } from "../components/podcastDetails";

const Podcasts = () => {
  return (
    <div>
      <div className="podcast py-16 px-48 md:px-8 flex flex-col justify-center space-y-20">
        <div className="space-y-3 text-center">
          <h1 className="md:text-2xl">THE LEADING LADIES PODCAST</h1>
          <p className="md:text-sm">
            Leading Ladies is an animated podcast depicting 17th and 19th
            century Zambian women who held significant positions of leadership.
            These stories challenge the idea that historically, women were not
            capable of being leaders.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-1 gap-x-6 md:gap-x-0 gap-y-20 md:gap-y-10">
          {podcastDetails.map(({ title, date, image }) => (
            <div
              className="flex md:flex-col flex-1 space-x-4 md:space-x-0 items-center md:gap-y-6"
              key={title}
            >
              <div className="justify-self-start">
                <img src={image} alt="" className="h-[184px]" />
              </div>
              <div className="space-y-3 md:text-sm md:text-center">
                <h4 className="font-semibold">{title}</h4>
                <h4 className="font-normal">{date}</h4>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Podcasts;
